<template>
  <div v-loading="listContentLoading">
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      clearable
      placeholder="请输入标题"
    ></el-input>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.status"
      clearable
      placeholder="状态"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="已发布" value="1">已发布</el-option>
      <el-option label="未发布" value="2">未发布</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="toCreate()"> 添加</el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 10px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column label="标题" align="center" min-width="25%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="时间" align="center" min-width="12%">
          <template slot-scope="{ row }">
            {{
              commonUtil.formatDateTime(row.begin_at, "yyyy-MM-dd") +
              " ~ " +
              commonUtil.formatDateTime(row.end_at, "MM-dd")
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="price"
          label="最低价"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="address"
          label="地址"
          align="center"
          min-width="12%"
        ></el-table-column>

        <el-table-column label="规格" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="toItemList(row.id)">
              规格
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="状态" align="center" min-width="12%">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.status == 1" style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 已发布</span
              >
              <span v-else style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未发布</span
              >
              <el-button
                type="text"
                size="small"
                style="margin-left: 5px;"
                @click="
                  row.status == 1
                    ? updateStatus(row.id, 0)
                    : updateStatus(row.id, 1)
                "
              >
                {{ row.status == 1 ? "下架" : "发布" }}
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="入住人信息" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              @click="openDialogInfoField(row.id, row.info_field)"
            >
              查看设置
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
            <el-button type="primary" size="mini" @click="viewURL(row.id)">
              分享
            </el-button>
            <el-button type="primary" size="mini" @click="lodgingOrderList(row.id)">
              订单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="查看或设置入住人信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="addEditFormOnClose"
      width="60%"
    >
      <el-row>
        <el-table
          :data="infoField"
          border
          size="mini"
          :stripe="true"
          style="width: 100%;"
        >
          <el-table-column label="名称" align="left" min-width="12%">
            <template slot-scope="{ row }">
              <el-input
                size="mini"
                v-model="row.key"
                clearable
                placeholder="请输入名称"
                style="width: 90%;"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column
            prop="type"
            label="类型"
            align="center"
            min-width="8%"
          >
            <template slot-scope="{ row }">
              <el-select
                size="mini"
                v-model="row.type"
                placeholder="请指定类型"
                filterable
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.type"
                  :label="item.name"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            label="默认值(多个值用英文逗号 , 隔开)"
            align="center"
            min-width="12%"
          >
            <template slot-scope="{ row }">
              <el-input
                size="mini"
                v-model="row.value"
                clearable
                placeholder="请输入默认值"
                style="width: 80%;"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column label="必填" align="center" min-width="8%">
            <template slot-scope="scope">
              <el-radio-group
                v-model="scope.row.required"
                :disabled="scope.$index < 2 ? true : false"
              >
                <el-radio :label="1" value="1">是</el-radio>
                <el-radio :label="0" value="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" min-width="3%">
            <template slot-scope="row">
              <i
                v-if="row.$index > 2"
                class="el-icon-remove"
                @click="delInfoField(row.$index)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px; text-align: right;">
          <el-button size="mini" @click="addNewInfoField()" type="danger" icon="el-icon-circle-plus" style="float: left;"
            >添加行</el-button
          >

          <el-button size="mini" @click="addEditFormOnClose()" type="info"
            >取消</el-button
          >
          <el-button size="mini" @click="setInfoField()" type="primary"
            >保存</el-button
          >
        </div>
      </el-row>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog
      title="地址"
      :visible.sync="dialogVisible2"
      width="50%"
    >
      <el-input
        v-model="liveURL"
        style="width:66%; margin-left: 256 /2; position: relative; left: 10%;"
      ></el-input>
      <div id="qrcode" style="margin-left: 256 /2; position: relative; left: 10%"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="copy(liveURL)">复制</el-button>
        <el-button type="primary" @click="dialogVisible2 = false; liveURL = ''"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getList, updateStatus, del, setInfoField, getLodgingURL } from "@/api/lodging";

import { qrCode, copyData } from "@/api/common";

export default {
  data: function () {
    return {
      liveURL: '',
      dialogVisible2: false,
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        title: "",
        status: "",
      },

      listContentLoading: false,

      infoField: [],
      infoField2: [],
      theLodgingId: 0,
      typeList: [
        { type: "input", name: "单行文本" },
        { type: "textarea", name: "多行文本" },
        { type: "radio", name: "单选框" },
        { type: "select", name: "下拉选项" },
      ],
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    lodgingOrderList(id) {
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=lodging&m=lodging_orders&p=52&id=' + id, '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=lodging&m=lodging_orders&p=52&id=' + id, '_blank');
      }
    },
    copy(url) {
      copyData(url)
      this.$message({
          message: '复制成功',
          type: 'success'
      })
    },
    viewURL(id) {
      getLodgingURL({
        id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.dialogVisible2 = true;
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            this.liveURL = response.data.url;
            let qrcode = qrCode(response.data.url, 300, 300);
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    setInfoField() {
      setInfoField({
        id: this.theLodgingId,
        info_field: this.infoField,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.addEditFormOnClose(false);
          this.getList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    addNewInfoField() {
      this.infoField.push({
        key: "",
        type: "input",
        value: "",
        required: 0,
      });
    },
    delInfoField(infoFieldIndex) {
      this.infoField.splice(infoFieldIndex, 1);
    },
    openDialogInfoField(id, info_field) {
      this.dialogVisible = true;
      this.theLodgingId = id;
      this.infoField = info_field;
      this.infoField2 = JSON.stringify(info_field);
      this.infoField.forEach((item) => {
        if (item.value != null) {
          item.value = item.value.toString();
        }
      });
    },
    // 弹窗关闭
    addEditFormOnClose(change = true) {
      this.dialogVisible = false;
      this.list.forEach((item) => {
        if (item.id == this.theLodgingId) {
          if (change) {
            item.info_field = JSON.parse(this.infoField2);
          } else {
            this.infoField2 = JSON.stringify(item.info_field);
          }
        }
      });
    },

    toItemList(id) {
      this.$router.push({
        path: "/lodging/itemList",
        query: {
          lodging_id: id,
        },
      });
    },
    toCreate(id) {
      this.$router.push({
        path: "/lodging/info",
        query: {
          id: id,
        },
      });
    },
    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateStatus(id, status) {
      updateStatus({
        id: id,
        status: status,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
